import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useDistributorForRegType } from '@interlayer/js/app/components/main/Registration/hooks/useDistributorForRegType';
import { useGtmEventReg } from '@interlayer/js/app/components/main/Registration/hooks/useGtmEventReg';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { resetToDefault } from '@interlayer/js/app/store/reducers/Registration/actions';

enum GTM_REG_ABORT_NAME {
    registration = 'registrationAborted',
    upgrade = 'upgradeAccountAborted',
    retailReg = 'retailRegAborted',
    retailUpgrade = 'retailUpgradeAborted',
    slotReg = 'slotRegAborted',
    slotUpgrade = 'slotUpgradeAborted',
}

export const useRegistrationDestroyed = () => {
    const dispatch = useDispatch();
    const gtmEventReg = useGtmEventReg();
    const { isRegistered, isDestroyed } = useRegistrationSelector();

    const gtmEventName = useDistributorForRegType(GTM_REG_ABORT_NAME);

    useEffect(() => {
        if (isDestroyed) {
            dispatch(resetToDefault());

            if (isRegistered) {
                return;
            }

            gtmEventReg(gtmEventName);
        }
    }, [dispatch, gtmEventName, gtmEventReg, isDestroyed, isRegistered]);
};
